import React, { useState } from 'react';
import { Facebook, Twitter, Link2, Check } from 'lucide-react';

export default function ShareButtons({ title, url }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title || '');

  const links = [
    {
      icon: Facebook,
      label: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      icon: Twitter,
      label: 'X',
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    },
    {
      icon: Link2,
      label: copied ? 'Copied' : 'Copy',
      href: null,
    },
  ];

  const handleClick = (link) => {
    if (link.href) {
      window.open(link.href, '_blank', 'noopener,noreferrer,width=600,height=500');
      return;
    }
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="flex items-center gap-2">
      {links.map((link) => (
        <button
          key={link.label}
          onClick={() => handleClick(link)}
          className="w-9 h-9 flex items-center justify-center border border-white/10 text-white/40 hover:text-white hover:border-primary/40 transition-colors"
          aria-label={`Share on ${link.label}`}
          title={link.label}
        >
          {link.label === 'Copied' || (copied && link.label === 'Copy') ? (
            <Check className="w-4 h-4 text-primary" />
          ) : (
            <link.icon className="w-4 h-4" />
          )}
        </button>
      ))}
    </div>
  );
}